import React from 'react';

import SharedDeviceLockoutDialog from 'auth/components/SharedDeviceLockoutDialog';
import useSharedDeviceLockout from 'auth/hooks/useSharedDeviceLockout';

interface Props {
  userId: string;
}

const SharedDeviceLockoutManager = ({ userId }: Props): JSX.Element => {
  const { step, onAnswerShared, onAnswerNotShared, onSwitchAccounts, onClose } =
    useSharedDeviceLockout(userId);

  return (
    <SharedDeviceLockoutDialog
      step={step}
      onAnswerShared={onAnswerShared}
      onAnswerNotShared={onAnswerNotShared}
      onSwitchAccounts={onSwitchAccounts}
      onClose={onClose}
    />
  );
};

export default SharedDeviceLockoutManager;
